import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';

export const readReportCampaignResponsesByCampaignId = async <
  T extends Record<string, unknown>,
>({
  query,
  campaignId,
  domain,
  headers,
}: // @todo - make sure this doesn't break anything
// qs: query,
FetchRequestArgs & { campaignId: string }): Promise<
  ReturnType<typeof fetchRequest>
> => {
  return fetchRequest<T>({
    domain,
    endpoint: `/reporting/campaign/${campaignId}/responses`,
    headers,
    query,
  });
};
